import {BaseAttribute, BaseAttributeOptions} from './BaseAttribute';

/** Options for string attributes (same as {@link BaseAttributeOptions} for now). */
export type StringAttributeOptions = BaseAttributeOptions;

/** Attribute for plain string fields. */
export class StringAttribute extends BaseAttribute {

  constructor(options: StringAttributeOptions = {}) {
    super(options);
  }

  getInitialValue(): unknown {
    return this.creationValue ? this.creationValue.toString() : undefined;
  }
}
